// extracted by mini-css-extract-plugin
var _1 = "AttachServiceRequestsStatusModal-modulemodal__ohMQ2 Modal-moduleModal__c1dw1";
export { _1 as "modal" }
